import type {
  AppointmentRepository,
  AppointmentStatus,
  AppointmentType,
  GetAppointmentsUC,
  SessionClient,
} from "@phurshell/psiapp-frontend-core/domain";
import { AccessDeniedError } from "@phurshell/psiapp-frontend-core/domain";

export class GetAppointments implements GetAppointmentsUC {
  constructor(
    private readonly appointmentRepo: AppointmentRepository,
    private readonly sessionClient: SessionClient,
  ) {}

  async execute(query?: {
    filter?: string;
    type?: AppointmentType;
    status?: AppointmentStatus;
    date_start?: string;
    date_end?: string;
  }) {
    const session = this.sessionClient.getSession();
    if (!session) throw new AccessDeniedError();

    const { status, ...rest } = query ?? {};
    return this.appointmentRepo.getAppointments({
      ...rest,
      psychologist_id: session.id,
      ...(status ? { status: [status] } : {}),
    });
  }
}
